import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			redirect: '/home',
			component: () => import('@/layouts/layouts-home'),
			children: [
				{
					name: 'pages-home',
					path: 'home',
					component: () => import('@/pages/home/pages-home'),
				},
			],
		},
		{
			path: '/politics',
			name: 'politics',
			component: () => import('@/components/politics/index'),
		},
	],
});



// WEBPACK FOOTER //
// ./src/router/index.js